import { render, staticRenderFns } from "./message-user-search.vue?vue&type=template&id=e5ccd37c&"
import script from "./message-user-search.vue?vue&type=script&lang=js&"
export * from "./message-user-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports